/*
 *  This file redirect-to-home-guard.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth-service';
import { TLoginTokenResponse } from '../models/common.models';
import { environment } from 'src/environments/environment';

@Injectable()
export class RedirectToHomeGuardService {

    constructor(
        public _authService: AuthService,
        public _router: Router
    ) {

    }

    canLoad(): boolean {
        const isHroneAuthWithToken = window.location.pathname.includes('hroneAuth') && window.location.search.includes('access_token');
        if (isHroneAuthWithToken) {
            return true;
        }
        if (this._authService.isAuthenticated()) {
            const allowedKBUrls = ['https://knowledge.hrone.cloud/', 'https://employee-help.hrone.cloud/'];
            const kbRedirectUrl = window.location.search.split('kbRedirectUrl=');
            const redirect_url = window.location.search.split('redirect_url=');
            const authloginStr = localStorage.getItem('authlogin');
            const allowedRedirectUrls = [
                `${this._authService._config.oneAIGPTUrl}/login`,
                `${this._authService._config.oneAIGPTUrl}/analytics`,
                this._authService._config.legoRedirectUrl,
                'https://oneai.test-analytics.hrone.work/login',
                'http://localhost:5173/login'
            ];
            const token: string = authloginStr ? JSON.parse(authloginStr)?.access_token : '';
            if (window.location.href.includes('/login?kbRedirectUrl=') && kbRedirectUrl.length > 1 && allowedKBUrls.some(prefix => decodeURIComponent(kbRedirectUrl[1]).startsWith(prefix))) {
                window.open(decodeURIComponent(kbRedirectUrl[1]) + '?access_token=' + token + '&auth=' + btoa(this._authService._config.base_auth_url), '_self');
                return false;
            }

            if (redirect_url.length > 1 && decodeURIComponent(window.location.href).includes(`${this._authService._config.base_auth_url}/api/file-download`)) {
                window.open(decodeURIComponent(redirect_url[1]), '_self');
                return false;
            }

            if (window.location.href.includes('/login?redirect_url=') && redirect_url.length > 1 && allowedRedirectUrls.includes(decodeURIComponent(redirect_url[1]))) {
                const oneAiReportContextStr = sessionStorage.getItem('oneAiReportContext');
                const isAnalyticsWithReport = redirect_url[1].endsWith('/analytics') && oneAiReportContextStr;
                let url: string;
                const authlogin: TLoginTokenResponse = JSON.parse(authloginStr || '{}');
                if (isAnalyticsWithReport) {
                    try {
                        const { reportname, url: reportUrl } = JSON.parse(oneAiReportContextStr);
                        sessionStorage.removeItem('oneAiReportContext');
                        url = this._authService.generateRedirectURLReports(decodeURIComponent(redirect_url[1]), authlogin, true, reportname, reportUrl);
                    } catch {
                        url = this._authService.generateRedirectURL(decodeURIComponent(redirect_url[1]), authlogin, true);
                    }
                } else {
                    url = this._authService.generateRedirectURL(decodeURIComponent(redirect_url[1]), authlogin, true);
                }
                window.open(url, '_self');
                return false;
            }
            const isProcessStart = JSON.parse(localStorage.getItem('isProcessStart') || 'false')
            const onboardingPageInfo = JSON.parse(localStorage.getItem('onboardingPageInfo') || '{}')

            if (isProcessStart && onboardingPageInfo) {
                if (onboardingPageInfo?.segmentTypeId) this._router.navigate(['/onboarding-config', onboardingPageInfo?.pageNumber, onboardingPageInfo?.segmentTypeId])
                else this._router.navigate(['/onboarding-config', onboardingPageInfo?.pageNumber])
                return false;
            }
            const logOnUserDetailsStr = localStorage.getItem('logOnUserDetails');
            const logOnUserDetails = logOnUserDetailsStr ? JSON.parse(logOnUserDetailsStr) : null;
            if (logOnUserDetails?.employeeStatusId == 7) {
                this._router.navigate(['app/inbox']);
                return false;
            }
            this._router.navigate(['app']);
            return false;
        } else {
            if (environment.redirectToMicro) {
                window.location.href = environment.loginRedirectUrl;
                return false;
            }
            return true;
        }
    }
}